import React from 'react';
import PropTypes from 'prop-types';

const UnycosLayout = ({ children, className }) => (
  <div className={className}>
    {children}
  </div>
);

UnycosLayout.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

export default UnycosLayout;
